<top-banner variant="title" title="Send Email"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">

    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="invite-users-side-padding">
              <h4 class="card-title">Send User Email</h4>
              <form [formGroup]="sendMailForm" (ngSubmit)="onSubmit()">
                <div class="form-row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>Subject</label>
                      <input type="text" class="form-control" formControlName="subject">
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>Content</label>
                      <textarea type="text" class="form-control" formControlName="content"></textarea>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-1">
                    <label for="mailAttachments"><img src="./assets/img/attachment.png" alt="Logo" width="30" height="40" style="cursor: pointer;"/></label>
                    <input
                    type="file"
                    style="display: none;"
                    name="mailAttachments"
                    id="mailAttachments"
                    accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .xlsx"
                    (change)="onFileChange($event)"
                    multiple/>
                  </div>
                  <div class="col-md-6">
                    <ng-container *ngIf="selectedAttachments.length">
                      <p>Selected Files: <a href="javascript:void(0)" (click)="selectedAttachments = []">&nbsp;clear</a></p>
                      <ul>
                        <li *ngFor="let file of selectedAttachments">{{ file.name }}</li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label><strong>Send Test Only?</strong> (email goes to Control Center Only)</label>
                      <p-checkbox class="form-control" formControlName="test" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <hr>
                    <div class="form-group form-group-checkbox">
                      <label>Send to site workers?<ng-container *ngIf="workerUserCount">:&nbsp;({{ workerUserCount }} valid emails)</ng-container></label>
                      <p-checkbox class="form-control" formControlName="workerUserGroup" binary="true" (onChange)="onWorkerUserGroupChange($event.checked)"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label>Send to site owners?<ng-container *ngIf="siteOwnerCount">:&nbsp;({{ siteOwnerCount }} valid emails)</ng-container></label>
                      <p-checkbox class="form-control" formControlName="siteOwnerGroup" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label>Send to site delegates?<ng-container *ngIf="siteDelegateCount">:&nbsp;({{ siteDelegateCount }} valid emails)</ng-container></label>
                      <p-checkbox class="form-control" formControlName="siteDelegateGroup" [disabled]="hideDelegateCheckBox" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label>Send to contractor managers?<ng-container *ngIf="contractorManagerCount">:&nbsp;({{ contractorManagerCount }} valid emails)</ng-container></label>
                      <p-checkbox class="form-control" formControlName="maintenanceManagerGroup" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-10">
                    <button type="submit" class="btn btn-success btn-round float-right" [disabled]="!sendMailForm.valid || sendInProgress">Send</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

